const TIER_NAMES = {
  starter: 'Starter',
  standard: 'Standard',
  pro: 'Pro',
  creator_plus: 'Creator+',
  elite: 'Elite',
  agency_scale: 'Agency Scale',
  agency: 'Agency',
  studio: 'Studio',
};

export function tierDisplayName(tier) {
  return TIER_NAMES[tier] || 'Starter';
}
